var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPropertyTypeIcon = function SvgPropertyTypeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 14.788h3.692V8.903h4.616v5.885H13v-9L7 1.25 1 5.788v9Zm-1 1v-10.5L7 0l7 5.288v10.5H8.308V9.903H5.692v5.885H0Z"
  })));
};
export default SvgPropertyTypeIcon;